import React from 'react';

import { getTranslateByScope } from '../../i18n';
import { fields } from './CustomerListConstants';
const translate = getTranslateByScope('customerList');

const ContactEntryHeader = () => {
  return (
    <thead>
      <tr>
        <th>SF | BC</th>
        {fields.map((f) => (
          <th scope='col' key={`header${f}`}>
            {translate('fields.' + f)}
          </th>
        ))}
        <th scope='col'>Options</th>
      </tr>
    </thead>
  );
};

export default ContactEntryHeader;
